<template>
  <div class="plots-component">
    <div class="title">
      <span>Список площадок</span>
    </div>
    <div v-if="!plotList.length" class="no-plot-msg" style='margin-bottom: 10px;'>
        <span>Площадки еще не добавлены</span>
      </div>
    <div class="add-block-outer">
      <button
        @click="enableAddMode"
        v-if="!addMode"
        :disabled="!actLpoIsDraft"
      >
        Добавить площадку
      </button>
      <input type="button" value="Импорт координат"  :disabled="!actLpoIsDraft" onclick="document.getElementById('import-plots').click();" />
      <input type="file" accept=".xlsx" style="display:none;" id="import-plots" ref="import-plots" name="file" @change="importExcelPlots($event.target)"/>
      <div v-if="addMode" class="add-block-container">
        <AddBlock @close="disableAddMode" />
      </div>
    </div>

    <div>
      <!-- <table v-else class='table-common plots-table'> -->
      <table v-if="plotList.length" class="plots-table table-common">
        <thead>
          <tr>
            <th>№</th>
            <th>Тип</th>
            <th>Широта</th>
            <th>Долгота</th>
            <th>Ширина, м</th>
            <th>Длина, м</th>
            <th>Площадь, га</th>
            <th>Количество деревьев</th>
            <!--<th v-if="recountIsOpen"></th>-->
            <th>Площадка</th>
          </tr>
          <!-- <tr>
						<th>Широта</th>
						<th>Долгота</th>
					</tr> -->
        </thead>
        <tbody>
          <template v-for="(plot, plot_i) in plotList">
            <template v-if="plot_i !== editedPlotNum">
              <tr v-for="(point, point_i) in plot.points">
                <td :rowspan="plot.points.length" v-if="point_i === 0">
                  {{ plot.num }}
                </td>
                <td :rowspan="plot.points.length" v-if="point_i === 0">
                  Лента
                </td>
                <td>{{ Number(point.lat).toFixed(6) }}</td>
                <td>{{ Number(point.lon).toFixed(6) }}</td>
                <td :rowspan="plot.points.length" v-if="point_i === 0">
                  {{ plot.radius_width }}
                </td>
                <td :rowspan="plot.points.length" v-if="point_i === 0">
                  {{ plot.length_manual || plot.length_calc}}
                </td>
                <td :rowspan="plot.points.length" v-if="point_i === 0">
                  {{ Number(plot.s_manual).toFixed(4) || Number(plot.s_calc).toFixed(4) }}
                </td>
                <td :rowspan="plot.points.length" v-if="point_i === 0">
                  {{ plot.trees_count }}
                  <button @click="openModalTrees1(plot)">Открыть список</button>
                </td>
                <td
                  :rowspan="plot.points.length"
                  v-if="point_i === 0"
                >
                  <button
                    @click="enableEditMode(plot, plot_i)"
                    :disabled="!actLpoIsDraft"
                  >
                    Редактировать
                  </button>
                  <button @click="rmPlot(plot)" :disabled="!(actLpoIsDraft && recountIsOpen) && (!recountIsOpen && plot.trees_count > 0)">
                    Удалить
                  </button>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="20">
                  <EditBlock @close="disableEditMode" :plot="editedPlot" />
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>

    <button
      class="toggle-recount-btn"
      v-if="plotList.length"
      @click="tggleRecount"
      :disabled="!actLpoIsDraft"
    >
      {{
        recountIsOpen
          ? "Перейти к внесению данных о модельных деревьях для установления разряда высот"
          : "Разблокировать перечет для редактирования"
      }}
    </button>

    <TreesModal
      :isOpen.sync="treesModalIsOpen"
      :preselectedPlot="selectedPlot"
      @hide="updatePlotList(lpo.id)"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import AddBlock from "./Recount__plotsLentAdd";
//import EditBlock from "./Recount__plotsLentEdit";
import EditBlock from "./Recount__plotsLentAdd";
import TreesModal from "./Recount__trees/TreesModal";

// import CustomModal from '@/lib/CustomModal.vue';

export default {
  name: "PlotsStrip",
  components: {
    AddBlock,
    EditBlock,
    TreesModal,
  },
  data: () => ({
    addMode: false,

    editedPlotNum: -1,
    editedPlot: null,

    modalEnvelopeIsOpen: false,

    addBlockIsOpen: false,

    treesModalIsOpen: false,
    selectedPlot: null,
  }),
  computed: {
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    lpo() {
      return this.$store.state.selectedLpo.lpo;
    },

    ...mapState("selectedLpo/recount", {
      plotList: (state) => state["plotList"],
      treeList: (state) => state["treeList"],
    }),

    ...mapGetters("selectedLpo/recount", ["recountIsOpen"]),
  },
  methods: {
    openModalTrees1(plot) {
      this.selectedPlot = plot;
      this.treesModalIsOpen = true;
    },

    enableAddMode() {
      
      this.openModalAddBlock();

      this.addMode = true;
    },

    disableAddMode() {
      this.addMode = false;
    },

    enableEditMode(plot, plot_i) {
      // this.openModalAddBlock();
      // return;

      this.editedPlot = plot;
      this.editedPlotNum = plot_i;
    },

    openModalAddBlock() {
      this.addBlockIsOpen = true;
    },

    disableEditMode() {
      this.editedPlotNum = -1;
      this.editedPlot = null;
    },

    rmPlot(plot) {
      if (+plot.trees_count) {
        const confirmation = confirm("Удалить площадку?");
        if (!confirmation) {
          return;
        }
      }

      this.removePlot(plot).then((res) => {
        this.updatePlotList(this.lpo.lpo_id);
      });
    },

    async tggleRecount() {
      const LayerIsCorrect = await this.checkIsLayerCorrect();

      if (this.recountIsOpen && LayerIsCorrect?.is_correct === "f") {
        this.$toast.add({
          severity: "warn",
          detail:
            "Условия для выделения второго яруса не выполнены (полнота менее 0,3)!",
          life: 10000,
        });
        return;
      }

      if (this.lpo.inspection_type_id === "1") {
        const sPlotIsCorrect = await this.checkSPlot();

        if (this.recountIsOpen && sPlotIsCorrect?.[0]?.s_plot_enough !== "t") {
          this.$toast.add({
            severity: "warn",
            detail: "Площадь выделенных лент недостаточна",
            life: 10000,
          });
          return;
        }
      }

      return this.toggleRecount(this.lpo.lpo_id).then((res) => {
        this.updatePlotList(this.lpo.lpo_id);
      });
    },

    ...mapActions("selectedLpo/recount", [
      "removePlot",
      "updatePlotList",
      "toggleRecount",
      "checkSPlot",
      "checkIsLayerCorrect",
      "importExcelPlots"
    ]),
  },
};
</script>

<style scoped lang="scss" src="@/style/tables.scss"></style>

<style scoped>
.title {
  font-size: 1rem;
  font-weight: bold;
  font-style: italic;
  margin-bottom: 10px;
}

.add-block-outer {
  margin-bottom: 10px;
}

.toggle-recount-btn {
  margin-top: 20px;
}

.flex-container {
  gap: 20px;
}
</style>
